<template>
  <div
    class="flex flex-col md:flex-row justify-between items-center gap-4 mt-6"
  >
    <!-- Info -->
    <div class="text-sm text-gray-500">
      Showing
      <span class="font-semibold text-gray-700">{{
        pagination.count || 0
      }}</span>
      of
      <span class="font-semibold text-gray-700">{{
        pagination.total || 0
      }}</span>
      results
    </div>

    <!-- Controls -->
    <div
      class="flex items-center gap-1 bg-white shadow-sm rounded-lg p-1 border"
    >
      <!-- First -->
      <button
        :disabled="!pagination.links?.first"
        @click="$emit('change-page', 1)"
        class="nav-btn"
        title="First page"
      >
        <i class="fas fa-angle-double-left"></i>
      </button>

      <!-- Prev -->
      <button
        :disabled="!pagination.links?.prev"
        @click="$emit('change-page', pagination.current_page - 1)"
        class="nav-btn"
        title="Previous page"
      >
        <i class="fas fa-angle-left"></i>
      </button>

      <!-- Page Info -->
      <div class="px-4 py-1 text-sm font-medium text-gray-700">
        Page
        <span class="font-bold text-blue-600">{{
          pagination.current_page || 1
        }}</span>
        /
        {{ pagination.total_pages || 1 }}
      </div>

      <!-- Next -->
      <button
        :disabled="!pagination.links?.next"
        @click="$emit('change-page', pagination.current_page + 1)"
        class="nav-btn"
        title="Next page"
      >
        <i class="fas fa-angle-right"></i>
      </button>

      <!-- Last -->
      <button
        :disabled="!pagination.links?.last"
        @click="$emit('change-page', pagination.total_pages)"
        class="nav-btn"
        title="Last page"
      >
        <i class="fas fa-angle-double-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "BasePagination",
  props: {
    pagination: { type: Object, required: true },
  },
};
</script>

<style scoped>
.nav-btn {
  @apply px-3 py-2 rounded-md text-gray-600 transition-all duration-200;
}

.nav-btn:hover {
  @apply bg-blue-100 text-blue-600;
}

.nav-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.nav-btn:disabled:hover {
  background: transparent;
  color: #9ca3af; /* gray-400 */
}
</style>
